import React, { useState, useEffect } from 'react';
import landingPageAPI from '../../services/api';
import BlogModal from './BlogModal';
import './BlogsSection.css';
import { getImageUrl } from '../../utils/imageUtils';

const BlogsSection = () => {
  const [title, setTitle] = useState('Insights on Modern Attendance Management');
  const [blogs, setBlogs] = useState([]);
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    try {
      const response = await landingPageAPI.getAllContent();
      if (response.data.status === 'success') {
        const sections = response.data.data.sections || [];
        const blogSection = sections.find(s => s.section_key === 'blogs');

        if (blogSection && blogSection.content) {
          const titleContent = blogSection.content.find(c => c.content_key === 'blogs_title');
          if (titleContent) setTitle(titleContent.content_value);
        }

        // Get blogs array from API (now comes from landing_page_blog table)
        const blogPosts = response.data.data.blog || [];

        // Filter only published posts
        const publishedBlogs = blogPosts.filter(blog => blog.is_published === 1 || blog.is_published === '1');

        setBlogs(publishedBlogs);
      }
    } catch (error) {
      console.error('Failed to fetch blogs:', error);
    }
  };

  const openBlog = (blog) => {
    setSelectedBlog(blog);
    setIsModalOpen(true);
  };

  const closeBlog = () => {
    setSelectedBlog(null);
    setIsModalOpen(false);
  };

  return (
    <>
      <section className="blogs-section" id="blogs">
        <div className="container">
          <div className="section-title">
            <h2>{title}</h2>
          </div>
          <div className="blogs-grid">
            {blogs.map((blog) => {
              const isVideo = blog.media_type === 'video';
              const hasImage = blog.featured_image && !isVideo;

              return (
                <div key={blog.id} className="blog-card" onClick={() => openBlog(blog)}>
                  {hasImage && (
                    <div className="blog-image">
                      <img src={getImageUrl(blog.featured_image)} alt={blog.title} />
                    </div>
                  )}
                  {isVideo && (
                    <div className="blog-video-preview">
                      <div className="video-play-icon">▶</div>
                      <div className="video-badge">Video</div>
                    </div>
                  )}
                  <div className="blog-content">
                    {blog.category && <span className="blog-category">{blog.category}</span>}
                    <h3>{blog.title}</h3>
                    <p>{blog.excerpt || blog.content?.substring(0, 150) + '...'}</p>
                    <div className="blog-meta">
                      {blog.author && <span className="blog-author">{blog.author}</span>}
                      {blog.publish_date && <span className="blog-date">{new Date(blog.publish_date).toLocaleDateString()}</span>}
                    </div>
                    <span className="read-more">{isVideo ? 'Watch Video' : 'Read More'} →</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {isModalOpen && (
        <BlogModal blog={selectedBlog} onClose={closeBlog} />
      )}
    </>
  );
};

export default BlogsSection;
